import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { IconCalendar, IconSearch, IconChevronDown } from "@tabler/icons-react";
import { formatDate, LocalStorageURL } from "../../../GlobalFunctions";
import { Button, rem, TextInput, MultiSelect } from "@mantine/core";
import { baseUrl, pdf, sorticon } from "../../../api/baseUrl";
import { DatePickerInput } from "@mantine/dates";
import { Link, useLocation } from "react-router-dom";
import Header from "../../../common/header/header";
import Search2 from "../search2";
import Nav from "../nav";
import Paginate from "react-paginate";

const News = (props) => {
  const location = useLocation();
  const [company, setCompany] = useState({});
  let compId = location.state != undefined ? location.state.id : 173;
  let symbol = company.symbol != undefined ? company.symbol : "LUCK";
  const [companyId, setCompanyId] = useState(compId);
  const [filings, setFilings] = useState([]);
  const [check, setCheck] = useState(false);
  const [cookies, setCookies, removeCookies] = useCookies();
  const [dateValue, setDateValue] = useState([null, null]);
  const [initialFilings, setInitialFilings] = useState([]);
  const [typeValue, setTypeValue] = useState([]);
  const [filter, setFilter] = useState([]);
  const [titleValue, setTitleValue] = useState("");

  const [url, setUrl] = useState(
    `${baseUrl}/news/${companyId}?page=1&postsperpage=1000`
  );

  useEffect(() => {
    if (company.id) {
      setCurrentPage(0);
      setUrl(`${baseUrl}/news/${company.id}?page=1&postsperpage=1000`);
    }
  }, [company.id]);

  useEffect(() => {
    fetch(url, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${cookies?.accessToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setFilings(data.data);
        setFilter(data.filter);
        if (initialFilings.length === 0) {
          setInitialFilings(data.data);
        }
        setCheck(true);
      });
  }, [url]);

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  const calendaricon = (
    <IconCalendar style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
  );
  const [currentPage, setCurrentPage] = useState(0);
  const [postsPerPage, setPostsPerPage] = useState(10);
  const [inputValue, setInputValue] = useState("");
  const indexOfLastPost = (currentPage + 1) * postsPerPage;
  const indexOfFirstPost = currentPage * postsPerPage;
  const currentPosts = filings.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = ({ selected }) => {
    setCurrentPage(selected);
  };

  // const handleTitle = (value) => {
  //   if (value !== undefined && value !== null) {
  //     let url2 = url;
  //     if (value.length) {
  //       url2 = removeParam("title", url2);
  //       url2 = url2.replace(`page=${currentPage}`, `page=1`);
  //       url2 += `&title=${value.toString().toLowerCase()}`;
  //       setCurrentPage(1);
  //     }
  //     setTitleValue(value);
  //     setUrl(url2);
  //   }
  // };

  const handleTitle = (value) => {
    setTitleValue(value);
  };

  const handleSearch = (e) => {
    let url2 = url;

    if (!dateValue || !dateValue[0] || !dateValue[1]) {
      url2 = removeParam("date", url2);
    } else {
      const sd_time = new Date(dateValue[0]).getTime() / 1000;
      const ed_time = new Date(dateValue[1]).getTime() / 1000;
      url2 = removeParam("date", url2);
      url2 += `&date=${[sd_time, ed_time].toString()}`;
    }

    if (typeValue.length === 0) {
      url2 = removeParam("type", url2);
    } else {
      url2 = removeParam("type", url2);
      url2 += `&type=${typeValue.join(",")}`;
    }

    if (inputValue.trim() === "") {
      url2 = removeParam("title", url2);
    } else {
      url2 = removeParam("title", url2);
      url2 += `&title=${inputValue}`;
    }

    setUrl(url2);
    setCurrentPage(0);
  };

  function removeParam(key, sourceURL) {
    var rtn = sourceURL.split("?")[0],
      param,
      params_arr = [],
      queryString =
        sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
      params_arr = queryString.split("&");
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
        param = params_arr[i].split("=")[0];
        if (param === key) {
          params_arr.splice(i, 1);
        }
      }
      if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
  }

  const handleUserInput = (e) => {
    setInputValue(e.target.value);
  };

  const resetInputField = () => {
    setInputValue("");
    setTypeValue([]);
    setDateValue([null, null]);
    setCurrentPage(0);
    setFilings(initialFilings);
  };

  const handlePostsPerPage = (e) => {
    setCurrentPage(0);
    setPostsPerPage(e.target.value);
  };

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });

    const sortedData = [...filings].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === "ascending" ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === "ascending" ? 1 : -1;
      }
      return 0;
    });

    setFilings(sortedData);
  };

  const handleTypeValue = (value) => {
    setTypeValue(value);
  };

  return (
    <>
      <Header />
      <Search2
        companyId={companyId}
        setCompanyId={setCompanyId}
        setCompany={setCompany}
      />
      <Nav companyId={companyId} />

      <div className="filling_section">
        <div className="container container_box">
          <div className="search-box-filter">
            <div className="filings-date-field reseach-date-field search-filter-field">
              <TextInput
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                searchable
                placeholder="Search..."
                className="research-report-field"
                label="Title"
                rightSection={<IconSearch size="1rem" />}
                rightSectionWidth={30}
                styles={{ rightSection: { pointerEvents: "none" } }}
              />
            </div>
            <div className="filings-date-field reseach-date-field search-filter-field">
              <DatePickerInput
                clearable
                type="range"
                value={dateValue}
                onChange={setDateValue}
                valueFormat="DD MMM, YYYY"
                placeholder="Select Date Range"
                label="Date"
                className="news-date-picker"
                mx="auto"
                icon={<IconCalendar size="1.1rem" stroke={1.5} />}
              />
            </div>

            <div className="filter-text-field search-filter-field">
              <MultiSelect
                data={filter.type || []}
                value={typeValue}
                onChange={handleTypeValue}
                className="multi-icon-bar"
                rightSection={null}
                icon={<IconChevronDown size="1.1rem" stroke={1.5} />}
                nothingFound="Nothing found"
                label="Outlook"
                searchable
                placeholder="Select Type"
              />
            </div>
            <div className="search-clear-button">
              <Button className="search-btn-stle" onClick={handleSearch}>
                Search
              </Button>
              <Button
                onClick={resetInputField}
                className="search-btn-stle clear-btn-stl"
              >
                Clear
              </Button>
            </div>
          </div>
          <div className="excel-btn">
            <div className="select_drop">
              <select
                className="selectpicker"
                value={postsPerPage}
                onChange={handlePostsPerPage}
              >
                <option data-tokens="10">10</option>
                <option data-tokens="25">25</option>
                <option data-tokens="50">50</option>
                <option data-tokens="100">100</option>
              </select>
            </div>
          </div>
          <div className="ask-table-format table-scroll-responsive">
            <table className="table table-responsive">
              <thead>
                <tr>
                  <th
                    className="news-title-row"
                    onClick={() => handleSort("title")}
                  >
                    <div className="cement-steel-tbl">
                      Title
                      <div
                        className="sorticon"
                        dangerouslySetInnerHTML={{ __html: sorticon }}
                      />
                    </div>
                  </th>
                  <th onClick={() => handleSort("date")}>
                    <div className="cement-steel-tbl justify-align">
                      Date
                      <div
                        className="sorticon"
                        dangerouslySetInnerHTML={{ __html: sorticon }}
                      />
                    </div>
                  </th>
                  <th onClick={() => handleSort("description")}>
                    <div className="cement-steel-tbl">
                      Detail
                      <div
                        className="sorticon"
                        dangerouslySetInnerHTML={{ __html: sorticon }}
                      />
                    </div>
                  </th>
                  <th>
                    <div className="cement-steel-tbl justify-center">
                      Company/Sector
                    </div>
                  </th>
                  <th onClick={() => handleSort("type")}>
                    <div className="cement-steel-tbl justify-center">
                      Outlook
                      <div
                        className="sorticon"
                        dangerouslySetInnerHTML={{ __html: sorticon }}
                      />
                    </div>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {currentPosts.length ? (
                  currentPosts.map((item, index) => {
                    return (
                      <tr>
                        <td>
                          <Link
                            to={{ pathname: `${item.link}` }}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {item.title}
                          </Link>
                        </td>
                        <td className="right-align">{formatDate(item.date)}</td>
                        <td>{item.description.slice(0, 47)}...</td>
                        <td className="center-align">
                          <span className="sector-economy">{item.sector}</span>
                        </td>
                        <td className="center-align">
                          <span
                            className={
                              item.type == "Positive"
                                ? "positive-green"
                                : item.type == "Negative"
                                ? "negative-red"
                                : "neutral-grey"
                            }
                          >
                            {item.type}
                          </span>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center">
                      {check ? "No Record Found" : "Loading..."}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {currentPosts.length ? (
              <div className="dropdown-pagination">
                <Paginate
                  onPageChange={paginate}
                  pageCount={Math.ceil(filings.length / postsPerPage)}
                  previousLabel={"Prev"}
                  nextLabel={"Next"}
                  containerClassName={"pagination"}
                  pageLinkClassName={"page-number"}
                  previousLinkClassName={"page-number"}
                  nextLinkClassName={"page-number"}
                  activeLinkClassName={"active"}
                  forcePage={currentPage}
                />
              </div>
            ) : (
              ""
            )}
        </div>
      </div>
    </>
  );
};

export default News;
